import React from 'react';

const RefreshIcon = ({ color = '#6B7280', size = 12 }: { color?: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 2v3h-3M1.5 10V7h3M2.756 4.5a3.5 3.5 0 0 1 5.774-1.306L10.5 5M1.5 7l1.97 1.806A3.5 3.5 0 0 0 9.244 7.5"
      stroke={color}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RefreshIcon;
